import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";
import { Grid } from '@material-ui/core';

// components
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import DrawerPlacements from '../../../components/DrawerPlacements';
import UpdatePush from '../../../pages/pushNotifications/actions/edit';
import AddPush from '../../../pages/pushNotifications/actions/create';
import Delete from '../../../pages/pushNotifications/actions/delete';
import { GET_BY_ID } from "../../../queries/pushNotification";

const messages = ({ data: { messages, loading, error }}) => {
  const options = {
    responsive     : "scroll",
    selectableRows : 'checkbox',
    customToolbarSelect: selectedRows => (
      <Delete selectedRows = {selectedRows} messages={messages}/>
    )
  }

  const ActionsRow = (tableMeta) => {
    const id       = tableMeta.rowData[1];
    const language = tableMeta.rowData[3];
    const message  = tableMeta.rowData[2]; 
    const sendAt   = tableMeta.rowData[5];
    const title    = tableMeta.rowData[0]; 
    const url      = tableMeta.rowData[4];
    const publisherId      = tableMeta.rowData[6];

    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerPlacements title="Edit Push" iconButtonAction={false} labeButtonAction={title}>
          <UpdatePush id={id} language={language} message={message} sendAt={sendAt} title={title} url={url} publisherId={publisherId}></UpdatePush>
          </DrawerPlacements>
          </Grid>
          <Grid item xs={6}>
        </Grid>
      </Grid>
    );
  };

  return (<>
    <Grid container spacing={0}>
      <Grid item xs={10}>      
        <PageTitle title="Push Notifications" />
      </Grid>
      <Grid item xs={2}>          
        <DrawerPlacements title="Push" labeButtonAction="Add">
            <AddPush></AddPush>
        </DrawerPlacements>
      </Grid>
    </Grid>
    {
    (loading) ? <PageLoading /> : 
    (error) ? <PageError /> :
    (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <MUIDataTable
          title={false}
          data={messages}
          columns={[{
            labe    : "Title",
            name    : "title",
            options : {
              customBodyRender: (value, tableMeta, updateValue) => { 
                return (ActionsRow(tableMeta));
              },
              empty  : true,
              filter : true,
              sort   : true,
            }
          },{
            name   : "id",
            options: {
              display : false
            }
          },{
            label   : 'Message',
            name    : 'message'
          },{
            label   : 'Language',
            name    : 'language'
          },{
            label   : 'URL',
            name    : 'url'
          },{
            label   : 'Send At',
            name    : 'sendAt'
          },{
            name   : "publisherId",
            options: {
              display : false
            }
          }]}
          options={options}
        />
      </Grid>
    </Grid>
    )
    }
  </>);
};

export const Push = graphql(GET_BY_ID, { 
  options: (props) => ({ variables: { publisherId: localStorage.getItem('publisher-active') } })})(messages);